import React, { FunctionComponent } from 'react';
import DashboardLayout from '../../components/layout/layout';
import { Box, Grid, Paper, styled, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import SearchInventoryIcon from '../../assets/img/inventory_black.png';
//import UploadInventoryIcon from '../../assets/img/cuida_upload-outline_black.png';
import ListPriceLeadTimeIcon from '../../assets/img/Group181_black.png';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
//import RecentInventorySearch from '../../components/common/recent-inventory-search';

const ActionCard = styled(Paper)(({ theme }) => ({
  width: 180,
  height: 100,
  backgroundColor: '#f2f2f2',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '2px 2px 4px rgba(0,0,0,0.2)',
  borderRadius: 4,
  cursor: 'pointer',
  textAlign: 'center'
}));

const Inventory: FunctionComponent = () => {
  const navigate = useNavigate();
  //const detailedPermissions = useSelector((state: RootState) => state.permission.detailedPermissions) as any;
  
  const buttons = [
    { label: 'Search Inventory', icon: <img src={SearchInventoryIcon} alt="Search Inventory" style={{ width: 35, height: 40 }} />, navigateTo: '/inventory/search' },
    { label: 'List Price/ Lead Time', icon: <img src={ListPriceLeadTimeIcon} alt="Inventory" style={{ width: 40, height: 40 }} />, navigateTo: '/inventory/lead-time' },
    //...(detailedPermissions?.inventory?.uploadInventory ? [{ label: 'Upload Inventory', icon: <img src={UploadInventoryIcon} alt="Upload Inventory" style={{ width: 40, height: 40 }} />, navigateTo: '/inventory/upload' }] : []),
  ];
  
  return (
    <>
      <DashboardLayout titleIcon={<LockOutlinedIcon />} title={"Inventory"} initialBreadcrumbs={"Channel Partners"} levelBreadcrumbs={''} breadcrumbs={' Inventory'} activeMenu={'inventory'}>
        <Box sx={{ width: '100%', maxWidth: '100%' }}>
          <Grid container spacing={5}
            sx={{
              display: 'flex',
              justifyContent: 'normal',
              alignItems: 'center',
              maxWidth: '100%',
            }}
          >
            {buttons.map((btn, index) => (
              <Grid key={index} onClick={() => navigate(btn.navigateTo)}>
                <ActionCard sx={{ border: '1px solid #e1e1e1', boxShadow: ` inset 0 0 10px rgba(0, 0, 0, 0.1), inset 0 0 5px rgba(255, 255, 255, 0.6)` }}>
                  <Box position="relative">
                    {btn.icon}
                  </Box>
                  <Typography variant="body2" fontWeight="bold" mt={1}>
                    {btn.label}
                  </Typography>
                </ActionCard>
              </Grid>
            ))}
          </Grid>
          
          {/* <RecentInventorySearch /> */}
        </Box>
      </DashboardLayout>  
    </>
  )
};

export default Inventory;